// extracted by mini-css-extract-plugin
export default {"roomBackGroundContainer":"style_roomBackGroundContainer__TXura","backGroundShadow":"style_backGroundShadow__M6etR","backGroundImage":"style_backGroundImage__N2mCW"};